<script lang="ts" setup>
const props = defineProps({
  column: {
    default: undefined,
    type: Object as PropType<UColumn>,
  },
  disableSorting: {
    default: false,
    type: Boolean,
  },
  sortFields: {
    default: undefined,
    type: Object as PropType<SegmentationSortFields>,
  },
})

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const tooltip = computed(() => {
  if (!props.column?.sortKey) {
    return
  }

  if (!props.sortFields) {
    return
  }

  if (!props.sortFields[props.column.sortKey]) {
    return t('globals.sortAsc')
  }

  else if (props.sortFields[props.column.sortKey] === 'asc') {
    return t('globals.sortDesc')
  }

  else if (props.sortFields[props.column.sortKey] === 'desc') {
    return t('globals.sortRemove')
  }
})

function onSortColumn() {
  if (!props.column?.sortKey) {
    return
  }

  // Update sortFields
  const sortFields = { ...props.sortFields }

  if (!sortFields[props.column.sortKey]) {
    sortFields[props.column.sortKey] = 'asc'
  }

  else if (sortFields[props.column.sortKey] === 'asc') {
    sortFields[props.column.sortKey] = 'desc'
  }

  else {
    delete sortFields[props.column.sortKey]
  }

  router.push({
    name: route.name,
    params: { ...route?.params },
    query: {
      ...route?.query,
      page: 1,
      sortFields: new URLSearchParams(sortFields).toString(),
    },
  })
}
</script>

<template>
  <div
    class="flex w-full items-center"
    :class="{ 'pointer-events-none': !column?.sortKey || disableSorting }"
  >
    <UTooltip
      class="normal-case"
      :prevent="!tooltip"
      :text="tooltip"
    >
      <UButton
        class="px-1"
        color="white"
        :icon="column?.icon"
        variant="link"
        @click="onSortColumn"
      >
        {{ column?.label }}

        <UIcon
          v-if="column?.sortKey && sortFields?.[column?.sortKey]"
          class="ml-0.5 size-5 text-gray-600 dark:text-gray-400"
          :class="{ 'mt-0.5': sortFields[column.sortKey] === 'desc' }"
          :name="getIcon(sortFields[column.sortKey] === 'asc' ? 'sortAsc' : 'sortDesc')"
        />
      </UButton>
    </UTooltip>
  </div>
</template>
